<template>
  <div class="mettingAttendance">
    <NavBar :narBarTitle="$t('签到')" />
    <div class="switch">
      <span>{{ $t('是否开启签到') }}</span>
      <van-switch v-model="checked" />
    </div>
    <div class="content" v-if="checked">
      <div class="select" @click="toSelect">
        <div class="select-left">
          <img src="@/assets/images/setting.png" alt="" />
          <div class="select-font">
            {{ currentTemplate ? currentTemplate.name : $t('选择模版') }}
          </div>
        </div>
        <van-icon name="arrow" color="#999999" />
      </div>
      <div class="select-value" v-if="currentTemplate">
        <div
          class="select-value-item"
          v-for="item in currentTemplate.field.split(',')"
          :key="item"
        >
          {{ item }}
        </div>
      </div>
      <van-action-sheet
        v-model="show"
        :actions="templateList"
        :title="$t('选择一个模版')"
        @select="onSelect"
      />
    </div>
    <van-button round type="info" class="button" @click="submit">{{
      $t('确定')
    }}</van-button>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import Vue from 'vue'
import { getTemplateList, updateSignTemplate } from '@/services/api'
import { Switch, Button, ActionSheet, Icon, Toast } from 'vant'
Vue.use(Switch)
Vue.use(Button)
Vue.use(ActionSheet)
Vue.use(Icon)
Vue.use(Toast)

export default {
  name: 'MettingAttendance',
  components: {
    NavBar,
  },
  data() {
    return {
      checked: true,
      templateList: [],
      show: false,
      currentTemplate: null,
    }
  },
  methods: {
    async getTemplateList() {
      const data = {}
      const user = JSON.parse(localStorage.getItem('user'))
      if (user.companyId) {
        data['developerId'] = user.companyId
        data['companyId'] = user.companyId
        const res = await getTemplateList(data)
        this.templateList = res
        this.currentTemplate = res.find(
          (item) => item.id == this.$route.query.signTemplateId
        )
      }
    },
    onSelect(data) {
      this.currentTemplate = data
      this.show = false
    },
    toSelect() {
      if (this.templateList.length > 0) {
        this.show = true
      }
    },
    async submit() {
      if (this.checked) {
        if (!this.currentTemplate) {
          Toast.fail(this.$t('请选择模版'))
          return
        }
        const data = {
          id: this.$route.query.id,
          signTemplateId: this.currentTemplate.id,
        }
        await updateSignTemplate(data)
        Toast.success(this.$t('修改成功'))
        this.$router.back()
      } else {
        const data = {
          id: this.$route.query.id,
          signTemplateId: null,
        }
        await updateSignTemplate(data)
        Toast.success(this.$t('修改成功'))
        this.$router.back()
      }
    },
  },
  mounted() {
    this.getTemplateList()
    this.checked = this.$route.query.signTemplateId ? true : false
  },
}
</script>
<style lang="less" scoped>
.mettingAttendance {
  height: 100%;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  position: relative;
}
.switch {
  height: 48px;
  background: #ffffff;
  padding: 0 19px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  margin-bottom: 12px;
  span {
    color: #666666;
    font-size: 14px;
    line-height: 24px;
  }
}
.content {
  background: #ffffff;
  .select {
    height: 56px;
    background: #fefffe;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 19px;
    border-bottom: 1px solid #e8e8e9;
    .select-left {
      display: flex;
      align-items: center;
      img {
        height: 16px;
      }
      .select-font {
        padding-left: 8px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
  .select-value {
    padding: 0 20px;
    .select-value-item {
      height: 60px;
      display: flex;
      align-items: center;
      padding-left: 12px;
      border-bottom: 2px solid #e8e8e9;
      color: #333333;
      font-size: 16px;
    }
  }
}
.button {
  width: 350px;
  font-size: 16px;
  color: #ffffff;
  margin: 0 auto;
  position: absolute;
  bottom: 23px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
